import { render, staticRenderFns } from "./DescriptionsListItem.vue?vue&type=template&id=b0392f3a&"
import script from "./DescriptionsListItem.vue?vue&type=script&lang=js&"
export * from "./DescriptionsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports